// @flow
import React from 'react';
import { type SeriesItemData } from 'store/modules/profile';
import './UserSeriesList.scss';
import UserSeriesListItem from '../UserSeriesListItem';

type Props = {
  seriesList: SeriesItemData[],
};

const UserSeriesList = ({ seriesList }: Props) => {
  return (
    <div className="UserSeriesList">
      {seriesList && seriesList.length === 0 && <div className="no-series">시리즈가 없습니다.</div>}
      {seriesList.map(s => (
        <UserSeriesListItem series={s} key={s.id} />
      ))}
    </div>
  );
};

export default UserSeriesList;



// WEBPACK FOOTER //
// ./src/components/user/UserSeriesList/UserSeriesList.js